/** 官网首页：首屏、四样产物、价格、接入四步、生成模式、常见问题、结尾 CTA，以及首页里的产品片段与成功率面板。 */
const messages = {
  'meta.title': 'aitoken.tools · 一个 Key 接入 Seedance 2.0 视频生成',

  'reel.accepted': '202 Accepted · 冻结 {amount}',
  'reel.settled': '结算 {charged} · 退回 {released}',

  'hero.title.a': '一个 API Key',
  'hero.title.b': '接入 Seedance 2.0',
  'hero.rate.label': '生成成功率',
  'hero.rate.note': '近 {days} 天已结束的任务统计；用户取消、审核未通过、参数不合法的任务不计入。',
  'hero.lead': 'aitoken.tools：用一个 API Key 调用 Seedance 2.0 视频生成。提交、查询、回调和账单都对得上同一个任务 ID，按实际用量结算。',
  'hero.cta.create': '创建 API Key',
  'hero.cta.get': '获取 API Key',
  'hero.cta.docs': '阅读文档',
  'hero.aside.settle':
    '{site, select, cn {国内站} other {海外站}}按{currency, select, CNY {人民币} other {美元}}结算。',
  'hero.aside.bg': '背景为程序生成的示意画面。',

  'showcase.title': '一次调用，拿回四样东西',
  'showcase.lead':
    '从提交到对账，每一样都带着同一个任务 ID。下面是一个 720p、时长交给模型的任务，金额按本站当前价格算出。',
  'showcase.request.name': '请求',
  'showcase.request.line':
    '带上 Idempotency-Key 提交。网络抖动时用同一个 Key 重试，不会建出第二个任务，也不会多扣一次。',
  'showcase.receipt.name': '回执',
  'showcase.receipt.line': '立刻返回 202 和任务 ID。时长交给模型决定时，按 15 秒上界先冻结 {amount}。',
  'showcase.callback.name': '回调',
  'showcase.callback.line': '生成完成后签名推送到你的 callback_url，每个任务只推送一次最终结果。',
  'showcase.ledger.name': '账单',
  'showcase.ledger.line': '实际输出 {seconds} 秒，结算 {charged}，差额 {released} 当场退回可用额度。',

  'pricing.title': '按实际 token 计价',
  'pricing.lead':
    '用量 =（输入视频时长 + 输出时长）× 宽 × 高 × 帧率 ÷ 1024。提交时按上界冻结，结束后按实际用量结算，向上取整到分。',
  'pricing.error': '价格暂时无法加载',
  'pricing.empty': '本站暂未上架模型。上架后会在这里公布能力与价格，可以先阅读文档完成接入准备。',
  'pricing.caption': '{model} 价格（{currency}，每百万输出 token）',
  'pricing.captionShort': '{model} 价格（{currency}）',
  'pricing.head.noVideo': '不含视频输入（每百万 token）',
  'pricing.row.withVideo': '含视频输入（每百万 token）',
  'pricing.row.pixels': '16:9 输出尺寸',
  'pricing.row.fiveSec': '5 秒 16:9 文生视频',
  'pricing.popular': '最常用',
  'pricing.allModels': '全部模型、能力与价格',
  'pricing.try': '试一条 {resolution}',
  'pricing.registerToTry': '注册后试用',
  'pricing.m.resolution': '分辨率',
  'pricing.m.perMillion': '每百万 token',
  'pricing.m.withVideo': '含视频输入',
  'pricing.m.fiveSec': '5 秒视频',

  'onboard.contact.wechat': '微信 {id}',
  'onboard.contact.ops': '运营',
  'onboard.register.name': '注册',
  'onboard.register.clause': '先用邮箱注册账号',
  'onboard.register.body': '邮箱收到 6 位验证码，验证后直接进入控制台。注册免费。',
  'onboard.register.link': '去注册',
  'onboard.credit.name': '开通额度',
  'onboard.credit.clause': '再联系运营开通额度',
  'onboard.credit.body': '线下付款后把转账单号发给{contact}，运营核对后把额度发放到你的账号。',
  'onboard.key.name': '建 Key',
  'onboard.key.clause': '然后给应用建一个 Key',
  'onboard.key.body': '每个应用单独一个 Key，可以限定模型、权限和累计上限。完整 Key 只显示一次。',
  'onboard.key.link': 'Key 权限与限额',
  'onboard.task.name': '提交任务',
  'onboard.task.clause': '最后提交第一个任务',
  'onboard.task.body':
    '调用 /v1/videos/generations，轮询或用 Webhook 接收结果。任务列表里能看到每一笔花了多少。',
  'onboard.task.link': '快速开始',
  'onboard.slider.label': '接入步骤',
  'onboard.slider.valuetext': '第 {n} 步，共 {total} 步：{name}',
  'onboard.contactLink': '运营联系方式',
  'onboard.play': '自动播放',
  'onboard.pause': '暂停自动播放',

  'modes.title.a': '四种生成模式，',
  'modes.title.b': '同一个接口',
  'modes.fullTable': '看完整能力表',
  'modes.error': '模型能力暂时无法加载',
  'modes.empty': '本站暂未上架模型。',
  'modes.tablist': '生成模式',
  'modes.input': '输入',
  'modes.output': '输出 · 5 秒 · 720p',
  'modes.outputAlt': '输出画面示意',
  'modes.firstFrame.alt': '作为第一帧的沙丘静帧',
  'modes.firstFrame.fig': '第一帧',
  'modes.firstFrame.caption': '给一张图作为开场，模型从这一帧接着往下拍。',
  'modes.firstLast.firstAlt': '作为第一帧的晨雾山镇',
  'modes.firstLast.firstFig': '第一帧 · 清晨',
  'modes.firstLast.lastAlt': '作为最后一帧的入夜山镇',
  'modes.firstLast.lastFig': '最后一帧 · 入夜',
  'modes.firstLast.caption': '给出开头和结尾两帧，中间的过渡交给模型。',
  'modes.ref.bamboo': '竹林薄雾',
  'modes.ref.sea': '海面月光',
  'modes.ref.dunes': '沙丘长影',
  'modes.ref.alt': '参考图：{name}',
  'modes.ref.fig': '参考 · {name}',
  'modes.ref.caption': '几张参考图定下质感和色调，再用提示词描述镜头。',
  'modes.text.prompt': '“镜头缓缓推进，晨雾中的山间小镇，窗里亮着灯”',
  'modes.text.caption': '只写一段提示词，画面全部由模型生成。',
  'modes.band.input': '输入',
  'modes.band.resolution': '分辨率',
  'modes.band.duration': '时长',
  'modes.band.ratio': '比例',
  'modes.imgNote': '单张 ≤ {size}，边长 {min}–{max} px',
  'modes.firstFrame.title': '1 张图片作为第一帧',
  'modes.firstLast.title': '2 张图片：第一帧和最后一帧',
  'modes.ref.title': '图片 ≤ {images} 张 · 视频 ≤ {videos} 段 · 音频 ≤ {audios} 段',
  'modes.ref.note': '视频合计 ≤ {seconds} 秒',
  'modes.ref.noteAudio': '视频合计 ≤ {seconds} 秒；音频需同时提供图片或视频',
  'modes.text.title': '只要一段提示词',
  'modes.text.note': '最多 {n} 字',
  'modes.resolution.note': '1080p 单价更高，见上方价格',
  'modes.duration.note': '帧率固定 {fps} fps',
  'modes.ratio.note': '自适应按素材比例输出',

  'faq.title': '常见问题',
  'faq.1.q': '成功率是怎么算的？',
  'faq.1.a': '按近期已结束的任务计算：成功数 ÷（成功数 + 失败数）。用户主动取消、内容审核未通过和参数不合法的任务不计入。',
  'faq.2.q': '任务失败会扣费吗？',
  'faq.2.a': '不会。任务失败时冻结的额度全部退回。一个任务只结算一次，按实际输出计费，冻结的差额在任务结束时退回。',
  'faq.3.q': '内容审核没通过会怎样？',
  'faq.3.a': '任务直接失败并带上审核原因，冻结的额度退回。修改提示词或素材后可以重新提交。',
  'faq.4.q': '多久能拿到视频？',
  'faq.4.a': '取决于上游排队，无法保证完成时间。每个任务都有处理时限 deadline_at，到时未完成会失败并退回额度。',
  'faq.5.q': '怎么充值？',
  'faq.5.a': '线下付款后联系运营，运营核对单号把额度发放到你的账号。没有额度时也能先注册、建 Key、传素材、读文档。',
  'faq.6.q': '国内站和海外站通用吗？',
  'faq.6.a': '不通用。两站的账号、额度、Key 和任务完全隔离。',

  'cta.me.title.a': '回到控制台',
  'cta.me.title.b': '继续生成',
  'cta.me.button': '进入控制台',
  'cta.title': '今天就用',
  'cta.email': '邮箱',
  'cta.placeholder': '你的邮箱',
  'cta.submit': '注册',
  'cta.note': '注册免费。额度由运营在确认线下付款后发放；没有额度也能先建 Key、传素材、读文档。',

  'frag.request.meta': 'duration -1：时长交给模型',
  'frag.receipt.meta': '按 15 秒上界冻结',
  'frag.webhook.meta': '签名推送，只推一次',
  'frag.ledger.title': '额度记录',
  'frag.ledger.meta': '起始可用 {amount}',
  'frag.ledger.time': '时间',
  'frag.ledger.type': '类型',
  'frag.ledger.amount': '金额',
  'frag.ledger.available': '可用额度',
  'frag.ledger.reserve': '冻结',
  'frag.ledger.reserve.note': '提交任务，按上界冻结',
  'frag.ledger.settle': '结算',
  'frag.ledger.settle.note': '实际 {tokens} token，从冻结中扣',
  'frag.ledger.release': '释放',
  'frag.ledger.release.note': '冻结差额退回可用额度',
  'frag.ledger.total': '这个任务一共花了',
  'frag.register.title': '注册 aitoken.tools',
  'frag.register.step': '第 2 步，共 2 步',
  'frag.register.email': '邮箱',
  'frag.register.code': '邮箱验证码',
  'frag.register.submit': '验证并进入控制台',
  'frag.credit.available': '可用额度',
  'frag.credit.reserved': '冻结中 {amount}',
  'frag.credit.grant': '发放',
  'frag.credit.note': '运营核对转账单号 {ref} 后发放',
  'frag.key.created': 'Key 已创建',
  'frag.key.once': '只显示这一次，请立即保存',
  'frag.key.name': '名称',
  'frag.key.nameValue': '剪辑 App · 生产',
  'frag.key.model': '模型',
  'frag.key.limit': '累计上限',
  'frag.task.title': '任务',
  'frag.task.today': '今天 1 个',
  'frag.task.done': '已完成',
  'frag.task.params': '720p · 16:9 · 自动时长（8 秒）',

  'board.label': '生成成功率',
  'board.window': '近 {days} 天',
  'board.models': '模型',
  'board.perThousand': '每 1000 个任务，{ok} 个成功',
  'board.legend.ok': '成功',
  'board.legend.failed': '失败',
  'board.done': '已完成',
  'board.result': '8 秒 · 720p',
  'board.settled': '结算 {amount}',

  'film.title': '火车进站，1897',
  'film.body':
    '卢米埃尔兄弟用手摇的 Cinématographe 拍下这不到一分钟的镜头，这台机器既能拍摄也能放映。现在，一段 15 秒以内的镜头只需要一段提示词和一次 API 调用。',
  'film.camera.alt': '1896 年的卢米埃尔 Cinématographe 摄影放映机，放在秤上拍摄的档案照片',
  'film.camera.caption': 'Cinématographe，1896',
  'film.poster.alt': '1895 年巴黎卢米埃尔电影放映的宣传海报',
  'film.poster.caption': '首映海报，1895',
  'film.video.label': '卢米埃尔兄弟《火车进站》（1897）片段，无声循环',
  'film.credit':
    '《L’Arrivée d’un train en gare de La Ciotat》，卢米埃尔兄弟，1897。公有领域，经 Wikimedia Commons。这不是 Seedance 生成的视频。',
};

export default messages;
